import { useEffect, useState } from "react";
import { useBreadcrumbsStore } from "../store/breadcrumbs.store";
import { useTranslation } from "../hooks/useTranslation";
import { useWordPressPosts } from "../hook/wordpress/posts.wordpress.hook";
import { useWordPressStore } from "../store/wordpress.store";
import { useWordPressPages } from "../hook/wordpress/pages.wordpress.hook";
import { useWordPressPhotosFromActions } from "../hook/wordpress/photosFromActions.wordpress.hook";
import { useWordPressVideos } from "../hook/wordpress/videos.wordpress.hook";
import { useWordPressReferences } from "../hook/wordpress/references.wordpress.hook";
import { useWordPressWhatWeDo } from "../hook/wordpress/whatWeDo.wordpress.hook";
import { useWordPressSocials } from "../hook/wordpress/socials.wordpress.hook";
import { useWordPressMaterials } from "../hook/wordpress/materials.wordpress.hook";
import { useWordPressFilesToDownload } from "../hook/wordpress/filesToDownload.wordpress.hook";
import { WordPressUtil } from "../utils/WordPressUtil";
import { useWordPressCategories } from "../hook/wordpress/categories.wordpress.hook";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import FsLightbox from "fslightbox-react";
import MarketingIco from "./Marketing/MarketingIco";
import MarketingTeam from "./Marketing/MarketingTeam";

function Vendors() {
  const { t } = useTranslation();
  const wordPressPhotosFromActionsMutation = useWordPressPhotosFromActions();
  const wordPressPostsMutation = useWordPressPosts();
  const wordPressVideosMutation = useWordPressVideos();
  const wordPressReferencesMutation = useWordPressReferences();
  const wordPressWhatWeDoMutation = useWordPressWhatWeDo();
  const wordPressSocialsMutation = useWordPressSocials();
  const wordPressMaterialsMutation = useWordPressMaterials();
  const wordPressFilesToDownloadMutation = useWordPressFilesToDownload();
  const wordPressPageMutation = useWordPressPages();
  const wordPressCategoriesMutation = useWordPressCategories();

  const posts = useWordPressStore((state) => state.posts);
  const pages = useWordPressStore((state) => state.pages);
  const videos = useWordPressStore((state) => state.videos);
  const references = useWordPressStore((state) => state.references);
  const whatWeDo = useWordPressStore((state) => state.whatWeDo);
  const socials = useWordPressStore((state) => state.socials);
  const materials = useWordPressStore((state) => state.materials);
  const filesToDownload = useWordPressStore((state) => state.filesToDownload);
  const photosFromActions = useWordPressStore(
    (state) => state.photosFromActions
  );
  const categories = useWordPressStore((state) => state.categories);

  const setBreadcrumbs = useBreadcrumbsStore((state) => state.setBreadcrumbs);
  const setPagename = useBreadcrumbsStore((state) => state.setPagename);

  useEffect(() => {
    setPagename(t("marketing.title"));
    setBreadcrumbs([]);
  }, []);

  useEffect(() => {
    wordPressPhotosFromActionsMutation.mutate();
    wordPressPostsMutation.mutate();
    wordPressPageMutation.mutate();
    wordPressVideosMutation.mutate();
    wordPressReferencesMutation.mutate();
    wordPressWhatWeDoMutation.mutate();
    wordPressSocialsMutation.mutate();
    wordPressMaterialsMutation.mutate();
    wordPressFilesToDownloadMutation.mutate();
    wordPressCategoriesMutation.mutate();
  }, []);

  const [selectedCategory, setSelectedCategory] = useState(null);
  const [showGallery, setShowGallery] = useState({});
  const [wholeReference, setWholeReference] = useState({});

  const pageVideosId = 63;
  const pagePhotosFromActionsId = 65;
  const pageAboutUsId = 77;
  const pageReferencesId = 67;
  const pagePostsId = 69;
  const pageWhatWeDoId = 71;

  let filterPosts = posts;
  if (filterPosts?.length > 0 && selectedCategory !== null) {
    filterPosts = filterPosts.filter((post) =>
      post.categories.includes(selectedCategory)
    );
  }
  filterPosts = filterPosts?.slice(0, 5);

  return (
    <>
      <div className="row">
        <div className="col-md-3">
          <div className="card p-4">
            <h1>
              {WordPressUtil.findById(pages, pageAboutUsId)?.title?.rendered}
            </h1>
            <div
              dangerouslySetInnerHTML={{
                __html: WordPressUtil.findById(pages, pageAboutUsId)?.content
                  ?.rendered,
              }}
            />
            <h2>{t("marketing.team")}</h2>
            <div className="mb-4">
              <MarketingTeam/>
            </div>
            <h2>
              {WordPressUtil.findById(pages, pageWhatWeDoId)?.title?.rendered}
            </h2>
            <div
              dangerouslySetInnerHTML={{
                __html: WordPressUtil.findById(pages, pageWhatWeDoId)?.content
                  ?.rendered,
              }}
            />

            {wordPressWhatWeDoMutation.isLoading ? (
              t("common.loading")
            ) : whatWeDo?.length > 0 ? (
              <div className="row row--5">
                {whatWeDo?.map((social, social_key) => (
                  <div className="col-3 mb-4" key={social_key}>
                    <MarketingIco icon={social} />
                  </div>
                ))}
              </div>
            ) : (
              t("marketing.linksNotFound")
            )}
            <div className="text-center">
              <a href="#" className="btn btn-primary">
                {t("marketing.interested")}
              </a>
            </div>
          </div>
        </div>
        <div className="col-md-7">
          <div className="card p-4">
            <h1 className="text-center mb-4">
              {WordPressUtil.findById(pages, pagePostsId)?.title?.rendered}
            </h1>
            {wordPressCategoriesMutation.isLoading ? (
              t("common.loading")
            ) : categories?.length > 0 ? (
              <ul className="mb-5 nav nav-stretch justify-content-center nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold">
                <li className="nav-item">
                  <span
                    onClick={() => setSelectedCategory(null)}
                    className={
                      "cursor-pointer nav-link" +
                      (selectedCategory === null ? " active" : "")
                    }
                    aria-current="page"
                  >
                    {t("common.all")}
                  </span>
                </li>

                {categories.map((category, category_key) => (
                  <li
                    className="nav-item"
                    key={category_key}
                    onClick={() => setSelectedCategory(category.id)}
                  >
                    <span
                      onClick={() => setSelectedCategory(category.id)}
                      className={
                        "cursor-pointer nav-link" +
                        (selectedCategory === category.id ? " active" : "")
                      }
                      aria-current="page"
                    >
                      {category.name}
                    </span>
                  </li>
                ))}
              </ul>
            ) : (
              t("marketing.categoriesNotFound")
            )}

            {wordPressPostsMutation.isLoading ? (
              t("common.loading")
            ) : filterPosts?.length > 0 ? (
              <div className="border-top-2 border-top pt-4">
                {filterPosts?.map((post, post_key) => (
                  <div
                    className="d-flex mb-4 pb-4 border-bottom-2 border-bottom border-active-warning"
                    key={post_key}
                  >
                    <div className="me-4 w-100px mw-100px" style={{flex:'0 0 100px'}}>
                      <img src={post.meta.thumbnail} alt="" width={100} style={{
                        aspectRatio: "1 / 1",
                        objectFit: "cover",
                      }}/>
                    </div>
                    <div className="flex-fill">
                      <h3
                          className="text-primary">
                            <strong
                            dangerouslySetInnerHTML={{
                              __html: post.title.rendered,
                            }}
                          />
                      </h3>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: post.content.rendered,
                        }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              t("marketing.newsNotFound")
            )}

            <h1 className="text-center mb-4">
              {
                WordPressUtil.findById(pages, pagePhotosFromActionsId)?.title
                  ?.rendered
              }
            </h1>

            {wordPressPhotosFromActionsMutation.isLoading ? (
              t("common.loading")
            ) : photosFromActions?.length > 0 ? (
              <div className="mb-5 px-5">
                <Slider
                  {...{
                    dots: false,
                    infinite: false,
                    speed: 500,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                  }}
                >
                  {photosFromActions?.map((photosFromAction, post_key) => (
                      <div key={post_key} className="px-3">
                        <div
                            onClick={() => {
                              setShowGallery({
                                [photosFromAction.id]: new Date().getTime(),
                              });
                            }}
                            className="overflow-hidden cursor-pointer card position-relative"
                        >
                          <img
                              src={photosFromAction.meta.fotky[0]?.guid}
                              style={{objectFit: "cover", aspectRatio: "3/2"}}
                              className="img-fluid"
                          />
                        </div>

                        <div
                            className="mt-2 text-center"
                            dangerouslySetInnerHTML={{
                              __html: photosFromAction.title.rendered,
                            }}
                        />
                      </div>
                  ))}
                </Slider>
                {photosFromActions?.map((photosFromAction, post_key) => (
                    <FsLightbox
                        key={post_key}
                        toggler={showGallery[photosFromAction.id]}
                        sources={photosFromAction.meta.fotky?.map((f) => f.guid)}
                  />
                ))}
              </div>
            ) : (
              t("marketing.photosNotFound")
            )}

            <h1 className="text-center mb-4">
              {WordPressUtil.findById(pages, pageVideosId)?.title?.rendered}
            </h1>

            {wordPressVideosMutation.isLoading ? (
              t("common.loading")
            ) : videos?.length > 0 ? (
                <div className="mb-4 px-8">
                  <div className="row ">
                    {videos?.map((video, post_key) => (
                      <div className="col-sm-6" key={post_key}>
                        <iframe
                          width="100%"
                          style={{ aspectRatio: "16/9" }}
                          src={video.meta.url_videa}
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                          referrerPolicy="strict-origin-when-cross-origin"
                          allowFullScreen
                        />
                      </div>
                    ))}
                  </div>
                </div>
            ) : (
              t("marketing.videosNotFound")
            )}

            <h1 className="text-center mb-4">
              {WordPressUtil.findById(pages, pageReferencesId)?.title?.rendered}
            </h1>

            {wordPressReferencesMutation.isLoading ? (
              t("common.loading")
            ) : references?.length > 0 ? (
              <div className="px-5">
                <Slider
                  {...{
                    dots: false,
                    infinite: false,
                    speed: 500,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                  }}
                >
                  {references?.map((reference, reference_key) => (
                    <div key={reference_key}>
                      <div className={"px-3"}>
                        <div className="card p-4">
                          <div className="mb-4">
                            <img
                              src={reference.meta.logo.guid}
                              height={60}
                              style={{ objectFit: "contain" }}
                              className="m-auto"
                            />
                          </div>
                          {reference_key in wholeReference && wholeReference[reference_key] ? (
                            <>
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: reference.meta.text,
                                }}
                              />
                              {reference.meta.text.length > 220 && (
                                  <div className="mt-2">
                                    <a
                                        href="javascript:;"
                                        onClick={() =>
                                            setWholeReference({
                                              ...wholeReference,
                                              [reference_key]: false,
                                            })
                                        }
                                    >
                                      <strong>{t("common.showLess")}</strong>
                                    </a>
                                  </div>
                              )}
                            </>
                          ) : (
                            <>
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: reference.meta.text.substring(0, 220),
                                }}
                              />
                              {reference.meta.text.length > 220 && (
                                <div className="mt-2">
                                  <a
                                    href="javascript:;"
                                    onClick={() =>
                                      setWholeReference({
                                        ...wholeReference,
                                        [reference_key]: true,
                                      })
                                    }
                                  >
                                    <strong>{t("common.showAll")}</strong>
                                  </a>
                                </div>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </Slider>
              </div>
            ) : (
              t("marketing.referencesNotFound")
            )}
          </div>
        </div>
        <div className="col-md-2">
          <div className="card p-4">
            <h2 className="text-center">{t("marketing.quickAccess")}</h2>
            <h3 className="text-center">{t("marketing.socialNetworks")}</h3>

            {wordPressSocialsMutation.isLoading ? (
              t("common.loading")
            ) : socials?.length > 0 ? (
              <div className="row row--5">
                {socials?.map((social, social_key) => (
                  <div className="col-6 mb-4" key={social_key}>
                    <MarketingIco icon={social} />
                  </div>
                ))}
              </div>
            ) : (
              t("marketing.linksNotFound")
            )}

            <h3 className="text-center">{t("marketing.downloads")}</h3>
            {wordPressSocialsMutation.isLoading ? (
              t("common.loading")
            ) : filesToDownload?.length > 0 ? (
              <div className="row row--5">
                {filesToDownload?.map((fileToDownload, fileToDownload_key) => (
                  <div className="col-6 mb-4" key={fileToDownload_key}>
                    <MarketingIco icon={fileToDownload} />
                  </div>
                ))}
              </div>
            ) : (
              t("marketing.linksNotFound")
            )}
            {/*
            <h3>Materiály</h3>
            {wordPressMaterialsMutation.isLoading ? (
              t("common.loading")
            ) : materials?.length > 0 ? (
              <div className="row row--5">
                {materials?.map((material, material_key) => (
                  <div className="col-6 mb-4" key={material_key}>
                    <MarketingIco icon={material} />
                  </div>
                ))}
              </div>
            ) : (
              t("marketing.linksNotFound")
            )}
            */}
          </div>
        </div>
      </div>
      {/*
            {JSON.stringify(categories)}<br/><br/>
            {JSON.stringify(videos)}<br/><br/>
            {JSON.stringify(materials)}<br/><br/>
            {JSON.stringify(socials)}<br/><br/>
            {JSON.stringify(whatWeDo)}<br/><br/>
            {JSON.stringify(filesToDownload)}<br/><br/>
            {JSON.stringify(references)}<br/><br/>
            {JSON.stringify(photosFromActions)}<br/><br/>
            {JSON.stringify(pages)}<br/><br/>
            {JSON.stringify(posts)}
            */}
    </>
  );
}

export default Vendors;
